import { NavLink } from "react-router-dom";
import { List, ListItem, ListItemText, ListSubheader } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  caseId: string | number;
  className?: string;
}

export function CaseNavigation(props: Props) {
  const { t } = useTranslation();

  return (
    <List
      className={props.className}
      component="nav"
      subheader={
        <ListSubheader className="list-sub-header" component="div">
          {t("label.case")}
        </ListSubheader>
      }
    >
      <ListItem button component={NavLink} to={`/cases/${props.caseId}/general-settings`}>
        <ListItemText primary={t("label.generalSettings")} />
      </ListItem>
      <ListItem button component={NavLink} to={`/cases/${props.caseId}/grid-settings`}>
        <ListItemText primary={t("label.gridSettings")} />
      </ListItem>
      <ListItem button component={NavLink} to={`/cases/${props.caseId}/pois`}>
        <ListItemText primary={t("label.pointsOfInterest")} />
      </ListItem>
    </List>
  );
}
